import { environment } from '@env/environment';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';

import { authReducer } from './auth/auth.reducer';
import { AuthState } from './auth/auth.state';
import { demandReducer } from './demand/demand.reducer';
import { DemandState } from './demand/demand.state';
import { globalReducer } from './global/global.reducer';
import { GlobalState } from './global/global.state';
import { settingsReducer } from './settings/settings.reducer';
import { SettingsState } from './settings/settings.state';
import { monitoringReducer } from './monitoring/monitoring.reducer';
import { MonitoringState } from './monitoring/monitoring.state';

export interface AppState {
  auth: AuthState;
  settings: SettingsState;
  demand: DemandState;
  global: GlobalState;
  monitoring: MonitoringState;
}

export const reducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  settings: settingsReducer,
  demand: demandReducer,
  global: globalReducer,
  monitoring: monitoringReducer,
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];
